/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

export var AccountType = /*#__PURE__*/function (AccountType) {
  AccountType["GOOGLE"] = "GOOGLE";
  AccountType["OFFICE_365"] = "OFFICE_365";
  AccountType["EMAIL_PASSWORD"] = "EMAIL_PASSWORD";
  return AccountType;
}({});